import type { IReportExportPort } from '@reports/application/ports';
import type { BlockDataRequestDto } from '@reports/application/dtos';
import type { ExportConfig } from '@reports/domain/value-objects';

/**
 * Use case for exporting report data
 *
 * Orchestrates the export process using the export port and configuration.
 *
 * @param exportPort - Repository implementing the export port
 * @returns Object with execute function
 *
 * @example
 * const useCase = exportRequestUseCase(exportRepository);
 * const blob = await useCase.execute(filters, exportConfig);
 */
export const exportRequestUseCase = (exportPort: IReportExportPort) => {
  /**
   * Executes the export use case
   *
   * @param request - Filters and date range for the export
   * @param exportConfig - Export configuration from report definition
   * @returns Promise with file blob
   */
  const execute = async (request: BlockDataRequestDto, exportConfig: ExportConfig): Promise<Blob> => {
    const reportBlob = await exportPort.exportReport(request, exportConfig);
    return reportBlob;
  };

  return { execute };
};
